import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["form", "startDate", "endDate", "periodField"]

  connect() {
    // Initialize any required setup
  }

  selectPeriod(event) {
    event.preventDefault()

    const period = event.currentTarget.dataset.period

    // Update the hidden period field
    if (this.hasPeriodFieldTarget) {
      this.periodFieldTarget.value = period
    }

    // Clear custom date fields when using preset
    if (this.hasStartDateTarget && this.hasEndDateTarget) {
      this.startDateTarget.value = ""
      this.endDateTarget.value = ""
    }

    // Submit the form
    this.submitFormElement()
  }

  submitForm() {
    // Clear custom date fields when using preset
    if (this.hasStartDateTarget && this.hasEndDateTarget) {
      this.startDateTarget.value = ""
      this.endDateTarget.value = ""
    }

    // Submit the form
    this.submitFormElement()
  }

  applyCustomRange(event) {
    // Prevent default submit to handle it ourselves
    event.preventDefault()
    this.submitFormElement()
  }

  submitFormElement() {
    if (this.hasFormTarget) {
      // Use submit() as fallback if requestSubmit isn't available
      if (typeof this.formTarget.requestSubmit === 'function') {
        this.formTarget.requestSubmit()
      } else {
        this.formTarget.submit()
      }
    }
  }
}
